import { antdTheme, ThemeConfig } from '@app/ui';

export const colorNavBg = '#E8E9EA';

export const colors10 = [
    '#1783FF',
    '#00C9C9',
    '#F0884D',
    '#D580FF',
    '#7863FF',
    '#60C42D',
    '#BD8F24',
    '#FF80CA',
    '#2491B3',
    '#17C76F',
];

const theme: ThemeConfig = {
    token: {
        colorPrimary: '#009FDF', // Relo Blue
        colorError: '#D4047D', // Relo Red
        colorWarning: '#FF7500', // Relo Orange
        colorSuccess: '#2DC850', // Relo Green
        colorTextBase: '#000000', // Relo Black
        colorBgLayout: '#E8E9EA', // Relo White Background
        colorBgContainer: '#FFFFFF', // Relo White Container
        // Primary hover, focus, and pressed states
        colorPrimaryHover: '#529EBD',
        colorPrimaryActive: '#045778',
        // Success hover state
        colorSuccessHover: 'rgba(45, 200, 80, 0.3)',
        // Warning hover and pressed states
        colorWarningHover: '#CB8504',
        colorWarningActive: '#9C561A',
        // Error hover and focus states
        colorErrorHover: '#E66FB1',
        colorErrorActive: '#B6066A',
        colorText: '#515252',
        fontSize: 14,
        fontFamily: 'Roboto, sans-serif',
        colorBorderSecondary: '#BFBFBF',
    },
    algorithm: antdTheme.defaultAlgorithm,
    components: {
        Layout: {
            lightSiderBg: colorNavBg,
        },
        Menu: {
            itemSelectedBg: '#d3dce0',
            itemActiveBg: '#A3BDC7',
            itemSelectedColor: '#0480B2',
            popupBg: colorNavBg,
            colorText: '#515252',
            fontSize: 14,
            groupTitleFontSize: 14,
        },
        Collapse: {
            headerBg: '#FAFAFA',
            colorBorder: '#BFBFBF',
            colorBgContainerDisabled: '#E8E9EA',
        },
        Tag: {
            colorBgBase: 'E6F4FF',
        },
        Select: {
            optionSelectedBg: '#E6F4FF',
        },
        DatePicker: {
            cellActiveWithRangeBg: '#E6F4FF',
        },
        Tabs: {
            itemHoverColor: '#009FDF',
            fontSize: 16,
        },
        Table: {
            headerBg: '#A3BDC7',
            headerColor: '#045778',
            footerBg: '#A3BDC7',
            footerColor: '#045778',
            borderColor: 'rgba(0, 0, 0, 0.06)',
            selectionColumnWidth: 33,
            rowSelectedBg: '#a4bdc7',
            rowSelectedHoverBg: '#d3dce0',
        },
        Button: {
            colorText: '#FFFFFF',
        },
    },
};

export default theme;
